//版本信息加载

import { system } from './systeminfo';
import util from '../../loader/utils/util';
var appUtils = {
  /**
   * Javascript内部的字符串，都以utf-16的形式进行保存，因此编码的时候，我们首先必须将utf-16的值转成utf-8再进行base64编码
   */
  utf16to8: function (str) {
    var out, i, len, c;
    out = '';
    len = str.length;
    for (i = 0; i < len; i++) {
      c = str.charCodeAt(i);
      if (c >= 0x0001 && c <= 0x007f) {
        out += str.charAt(i);
      } else if (c > 0x07ff) {
        out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f));
        out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f));
        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
      } else {
        out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f));
        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
      }
    }
    return out;
  },

  /**
   * 获取地域列表
   * @return {Promise}
   */
  getRegionList: function () { },
  /**
   * 查询可用区
   * @param {String} regionName 地域名称
   */
  getZone: function () { },
  /**
   * 查询当前地域
   * @return {String}
   */
  getRegion: function () { },
  /**
   * 设置当前地域
   * @param {String} region 地域名称
   */
  setRegion: function (region) { },

  /**
   * 返回本地存储的 regionId
   * @return {String}
   */
  getRegionId: function () { },
  /**
   * 设置地域 ID
   * @param {String} regionId 地域 Id
   */
  setRegionId: function (regionId) { },
  _getUrlRid: function (key) {
    var rid = '',
      regExp,
      ridMatch,
      valueKey = key + '=[^&]*';
    (regExp = new RegExp(valueKey)), (ridMatch = regExp.exec(location.href));
    if (ridMatch) {
      rid = ridMatch[0].split('=')[1];
    }
    return rid;
  },
  /**
   * 简易版parallel并行任务函数
   * @method parallel
   * @param {Array} tasks 函数数组
   * @param {Function} callback 回调
   * @author
   */
  parallel: function (tasks, callback) {
    var len = tasks.length,
      result = [],
      _callback = function (_result, i) {
        len--;
        result[i] = _result;
        if (len == 0) {
          callback && callback(result);
        }
      };
    for (var i = 0, fun; (fun = tasks[i]); i++) {
      (function (fun, i) {
        fun &&
          fun(
            function (_result) {
              _callback(_result, i);
            },
            function () {
              _callback(null, i);
            }
          );
      })(fun, i);
    }
  },

  /**
   * 修改url参数
   * @param url  需要修改的url
   * @param arg  需要修改的参数名
   * @param arg_val  修改后的值
   */
  changeURLArg: function (url, arg, arg_val) {
    var pattern = arg + '=([^&]*)';
    var replaceText = arg + '=' + arg_val;
    if (url.match(pattern)) {
      var tmp = '/(' + arg + '=)([^&]*)/gi';
      tmp = url.replace(eval(tmp), replaceText);
      return tmp;
    } else {
      if (url.match('[?]')) {
        return url + '&' + replaceText;
      } else {
        return url + '?' + replaceText;
      }
    }
    return url + '\n' + arg + '\n' + arg_val;
  },

  /**
   * 解析 GGW 返回的日期时间格式: 2015-01-15 21:15:20
   * @param {String}timeStr 日期字符串 (yyyy-MM-dd hh-mm-ss.mmm)
   * @author
   * */
  cgwTimeParse: function (timeStr) {
    var date = new Date(0);
    var methodArr = [
      'setFullYear',
      'setMonth',
      'setDate',
      'setHours',
      'setMinutes',
      'setSeconds',
      'setMilliseconds'
    ];
    var timeArr = timeStr.split(/[-\s\.\:]+/);
    var param;

    for (var i = 0, l = Math.min(timeArr.length, methodArr.length); i < l; i++) {
      if (i == 1) {
        param = timeArr[i] - 1;
      } else {
        param = timeArr[i] * 1;
      }
      date[methodArr[i]](param);
    }

    return date;
  },

  /**
   * UTC日期时间格式: 2015-01-15T21:15:20Z 转换为localTime: 2015-01-16 05:15:20
   * @param {String}timeStr 日期字符串 (yyyy-MM-ddThh:mm:ss.mmmZ)
   * @author
   * */
  convertUTCTimeToLocalTime: function (UTCDateString) {
    if (!UTCDateString) {
      return '-';
    }
    function formatFunc(str) {
      //格式化显示
      return str > 9 ? str : '0' + str;
    }
    var date2 = new Date(UTCDateString); //这步是关键
    var year = date2.getFullYear();
    var mon = formatFunc(date2.getMonth() + 1);
    var day = formatFunc(date2.getDate());
    var hour = formatFunc(date2.getHours());
    var min = formatFunc(date2.getMinutes());
    var sec = formatFunc(date2.getSeconds());
    var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + sec;
    return dateStr;
  },

  /**
   * @method formatDate
   * @param {Object} date Date对象
   * @param {String} fmt 格式化目标格式
   * @description 定义Date发format方法用于格式化日期
   * @author brianlin
   */
  formatDate: function (date, fmt) {
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      );
    var expMap = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      S: date.getMilliseconds()
    };
    for (var exp in expMap) {
      if (new RegExp('(' + exp + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? expMap[exp]
            : ('00' + expMap[exp]).substr(('' + expMap[exp]).length)
        );
      }
    }
    return fmt;
  },

  /**
   * 把date对象转成显示的日期  例如 2016-01-02 05:12:07
   * @param time
   * @returns {string}
   */
  getFormatTime: function (time) {
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    month = month - 10 < 0 ? '0' + month : month;
    var day = time.getDate();
    var hour = time.getHours();
    var moni = time.getMinutes();
    moni = Math.floor(moni / 5) * 5;
    day = day - 10 < 0 ? '0' + day : day;
    hour = hour - 10 < 0 ? '0' + hour : hour;
    moni = moni - 10 < 0 ? '0' + moni : moni;
    var second = time.getSeconds();
    second = second - 10 < 0 ? '0' + second : second;
    return year + '-' + month + '-' + day + ' ' + hour + ':' + moni + ':' + second;
  },

  /**
   * 获取一个区间时间
   * @param hourSpan
   * @returns {{beginTime: (*|string), nowTime: (*|string)}}
   */
  getTimeSpan: function (hourSpan) {
    hourSpan = hourSpan || 1;
    var self = this;
    var now = new Date();
    var pastHour = new Date(now.getTime() - 1000 * 60 * 60 * hourSpan);
    return {
      beginTime: self.getFormatTime(pastHour),
      nowTime: self.getFormatTime(now)
    };
  },

  /**
   * 把date日期对象转化为显示的文本日期  例如 2016-10-22
   * @param date
   * @returns {string}
   */
  dateToStr: function (date) {
    var span = '0',
      year = date.getFullYear(),
      month = date.getMonth() + 1,
      day = date.getDate();
    return [
      year,
      (month < 10 ? span : '') + month,
      (day < 10 ? span : '') + day
    ].join('-');
  },

  /**
   * 判断一个对象是否是数组，参数不是对象或者不是数组，返回false
   *
   * @param {Object} arg 需要测试是否为数组的对象
   * @return {Boolean} 传入参数是数组返回true，否则返回false
   */
  isArray: function (arg) {
    if (typeof arg === 'object') {
      return Object.prototype.toString.call(arg) === '[object Array]';
    }
    return false;
  },

  /**
   * 把文本的日期转化为Date对象  例如  '2016-10-22'
   * @param str
   * @returns {Date}
   */
  strToDate: function (str) {
    if (str == 'REALTIME') return new Date();

    var parts = str.split('-'),
      date = new Date(0);
    date.setFullYear(+parts[0], +parts[1] - 1, +parts[2]);
    return date;
  },

  /**
   * 获取一天的开始
   * @param date
   * @returns {Date|*}
   */
  toDayStart: function (date) {
    date = new Date(date.getTime());
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  },
  /**
   * 获取一天的结束 '2016-10-22 23:59:59'
   * @param date
   * @returns {Date|*}
   */
  toDayEnd: function (date) {
    date = new Date(date.getTime());
    date.setHours(23);
    date.setMinutes(59);
    date.setSeconds(59);
    date.setMilliseconds(0);
    return date;
  },

  checkIfIp: function (ip) {
    var ipReg = /^(?:(?:[1-9]?[0-9]|1[0-9]{2}|2(?:[0-4][0-9]|5[0-5]))\.){3}(?:[1-9]?[0-9]|1[0-9]{2}|2(?:[0-4][0-9]|5[0-5]))$/;
    return ipReg.test(ip);
  },
  /*将json格式格式化*/
  formatJson: function (json, options) {
    var reg = null,
      formatted = '',
      pad = 0,
      PADDING = '    ';

    options = options || {};
    options.newlineAfterColonIfBeforeBraceOrBracket =
      options.newlineAfterColonIfBeforeBraceOrBracket === true ? true : false;

    options.spaceAfterColon = options.spaceAfterColon === false ? false : true;

    if (typeof json !== 'string') {
      json = JSON.stringify(json);
    } else {
      json = JSON.parse(json);
      json = JSON.stringify(json);
    }

    reg = /([\{\}])/g;
    json = json.replace(reg, '\t\n$1\t\n');

    reg = /([\[\]])/g;
    json = json.replace(reg, '\t\n$1\t\n');

    reg = /(\,)/g;
    json = json.replace(reg, '$1\t\n');

    reg = /(\r\n\r\n)/g;
    json = json.replace(reg, '\t\n');

    reg = /\r\n\,/g;
    json = json.replace(reg, ',');

    if (!options.newlineAfterColonIfBeforeBraceOrBracket) {
      reg = /\:\r\n\{/g;
      json = json.replace(reg, ':{');
      reg = /\:\r\n\[/g;
      json = json.replace(reg, ':[');
    }
    if (options.spaceAfterColon) {
      reg = /\:/g;
      json = json.replace(reg, ':');
    }

    $.each(json.split('\t\n'), function (index, node) {
      var i = 0,
        indent = 0,
        padding = '';

      if (node.match(/\{$/) || node.match(/\[$/)) {
        indent = 1;
      } else if (node.match(/\}/) || node.match(/\]/)) {
        if (pad !== 0) {
          pad -= 1;
        }
      } else {
        indent = 0;
      }

      for (i = 0; i < pad; i++) {
        padding += PADDING;
      }

      formatted += padding + node + '\t\n';
      pad += indent;
    });

    return formatted;
  },
  debounce: function (func, wait, immediate) {
    // 定时器变量
    var timeout;
    return function () {
      // 每次触发 scroll handler 时先清除定时器
      clearTimeout(timeout);
      // 指定 xx ms 后触发真正想进行的操作 handler
      timeout = setTimeout(func, wait);
    };
  },
  /**
   * 普通对象深拷贝(不支持递归对象)
   * @param obj
   * @returns {Object}
   * @author justanzhu
   */
  clone: function clone(obj) {
    if (obj == null || typeof obj != 'object') {
      return obj;
    }
    var temp = new obj.constructor();
    for (var key in obj) {
      temp[key] = clone(obj[key]);
    }
    return temp;
  },

  /**
   * html模板生成器, =号转义, -号原始输出
   * @method tmpl
   * @param  {String} str html模板字符串 | script模版元素Id
   * @param  {Object} data 用于生成模板的数据对象
   * @param  {Object} [mixinTmpl] 混合模版对象
   * @return {String} 返回 html 字符串
   * @author evanyuan
   * @example
   *		var careerTmpl = '<div><%=career%></div>';
   * 		util.tmpl('<h1><%=user%></h1> <%#careerTmpl%>', {user:'evanyuan', career: '前端工程师'}, {careerTmpl: careerTmpl});
   */
  tmpl: (function () {
    var _cache = {},
      _escape = function (str) {
        if (str == 0) {
          return str;
        }
        str = (str || '').toString();
        return str
          .replace(/&(?!\w+;)/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/\"/g, '&quot;');
      },
      _getTmplStr = function (rawStr, mixinTmpl) {
        if (mixinTmpl) {
          for (var p in mixinTmpl) {
            var r = new RegExp('<%#\\s?' + p + '%>', 'g');
            rawStr = rawStr.replace(r, mixinTmpl[p]);
          }
        }
        return rawStr;
      };

    return function tmpl(str, data, mixinTmpl) {
      var strIsKey = !/\W/.test(str);
      !strIsKey && (str = _getTmplStr(str, mixinTmpl));

      var fn = strIsKey
        ? (_cache[str] =
          _cache[str] ||
          tmpl(_getTmplStr(document.getElementById(str).innerHTML, mixinTmpl)))
        : new Function(
          'obj',
          '_escape',
          "var _p='';with(obj){_p+='" +
          str
            .replace(/[\r\t\n]/g, ' ')
            .split("\\'")
            .join("\\\\'")
            .split("'")
            .join("\\'")
            .split('<%')
            .join('\t')
            .replace(/\t-(.*?)%>/g, "'+$1+'")
            .replace(/\t=(.*?)%>/g, "'+_escape($1)+'")
            .split('\t')
            .join("';")
            .split('%>')
            .join("_p+='") +
          "';} return _p;"
        );

      var render = function (data) {
        if (typeof data == 'object') {
          data.QCCONSOLE_HOST = window.QCCONSOLE_HOST;
          data.QCMAIN_HOST = window.QCMAIN_HOST;
          data.QCBUY_HOST = window.QCBUY_HOST;
        }
        return fn(data, _escape);
      };

      return data ? render(data) : render;
    };
  })(),
  parseQueryString: function (url) {
    var reg_url = /^[^\?]+\?([\w\W]+)$/,
      reg_para = /([^&=]+)=([\w\W]*?)(&|$)/g, //g is very important
      arr_url = reg_url.exec(url),
      ret = {};
    if (arr_url && arr_url[1]) {
      var str_para = arr_url[1],
        result;
      while ((result = reg_para.exec(str_para)) != null) {
        ret[result[1]] = decodeURIComponent(result[2]);
      }
    }
    return ret;
  },
  /**
   * 获取语言
   * 优先url,cookie,客制化，默认zh
   */
  getLanguage: function () {
    //url,cookie,window.language
    var search = util.paramsToObject(location.search) || {};
    var language = search.language || window.Language || util.cookie.get("tce_language") || util.cookie.get("Language");
    return language;
  },
  getDefaultLanguge: function () {
    var defaultLang = '';
    return defaultLang;
  },
  getImgcacheUrl: function () {
    if (window.QCIMGCACHE_HOST) {
      return '//' + window.QCIMGCACHE_HOST + '';
    } else if (window.TCE_DOMAIN) {
      return '//imgcache.' + window.TCE_DOMAIN;
    } else if (window.hostConfig && window.hostConfig.imagcache) {
      return window.hostConfig.imagcache;
    }
  }
};

export default appUtils;
